import { Accordion } from '@studiometa/ui';
import { FooterLinksDesktopAccordionItem } from './FooterLinksDesktopAccordionItem.js';

/**
 * FooterLinksDesktop class.
 */
export class FooterLinksDesktop extends Accordion {
  /**
   * Class config.
   * @type {object}
   */
  static config = {
    name: 'FooterLinksDesktop',
    components: {
      FooterLinksItems: FooterLinksDesktopAccordionItem,
    },
  };
}
